import { Navigate, useRoutes } from 'react-router-dom';
import BlankLayout from './layouts/BlankLayout';
import AdminLayout from './layouts/components';
import ActivityList from './pages/activity';
import CatalogList from './pages/catalog';
import Catalog from './pages/catalog/Catalog';
import Company from './pages/company';
import CouponList from './pages/coupon';
import CouponUseList from './pages/couponuse';
import Dashboard from './pages/dashboard';
import EventList from './pages/event';
import Event from './pages/event/Event';
import FaqList from './pages/faq';
import Faq from './pages/faq/Faq';
import FindCompany from './pages/find/company';
import FindProduct from './pages/find/product';
import FindUser from './pages/find/user';
import FollowUSList from './pages/followus';
import FollowUS from './pages/followus/FollowUS';
import FormDelivery from './pages/form/delivery';
import FormOrder from './pages/form/order';
import FormSpec from './pages/form/spec';
import GiftReqList from './pages/giftreq';
import GiftList from './pages/giftshop';
import InquiryList from './pages/inquiry';
import Inquiry from './pages/inquiry/Inquiry';
import Login from './pages/login';
import CategorySection from './pages/main/CategorySection';
import CategorySectionList from './pages/main/CategorySectionList';
import CommunityList from './pages/community';
import MainBanner from './pages/main/MainBanner';
import MainBannerList from './pages/main/MainBannerList';
import MainCategory from './pages/main/MainCategory';
import MainCategoryList from './pages/main/MainCategoryList';
import CustomerMap from './pages/map';
import Member from './pages/member/Member';
import MemberList from './pages/member/MemberList';
import MemberUpdate from './pages/member/MemberUpdate';
import StaffInfo from './pages/member/StaffInfo';
import StaffList from './pages/member/StaffList';
import Notice from './pages/notice/Notice';
import NoticeList from './pages/notice/NoticeList';
import NotFound from './pages/Page404';
import PointList from './pages/point';
import PopupList from './pages/popup';
import Popup from './pages/popup/Popup';
import AccountList from './pages/process/account';
import OrderList from './pages/process/order';
import OrderRegister from './pages/process/order/register';
import OrderManageList from './pages/process/ordermanage';
import ShingoList from './pages/process/shingo';
import SpecList from './pages/process/spec';
import SpecRegister from './pages/process/spec/register';
import OrderView from './pages/process/view';
import ProductList from './pages/product';
import BookingList from './pages/product/Booking';
import Category from './pages/product/Category';
import DocsList from './pages/product/Docs';
import NewProduct from './pages/product/NewProduct';
import Product from './pages/product/Product';
import QuestionList from './pages/question';
import Question from './pages/question/Question';
import ReviewList from './pages/review';
import Review from './pages/review/Review';
import SearchEngine from './pages/search';
import Mall from './pages/shop/Mall';
import Shop from './pages/shop/Site';
import StatList from './pages/stat';
import LeadList from './pages/lead';

// URL별 라우팅 정의
export default function Router() {
  return useRoutes([
    {
      path: '/admin',
      element: <AdminLayout />,
      children: [
        { path: 'activity', element: <ActivityList /> },
        { path: 'catalog', element: <CatalogList /> },
        { path: 'catalog/:id', element: <Catalog /> },
        { path: 'category', element: <CategorySectionList /> },
        { path: 'category/:id', element: <CategorySection /> },
        { path: 'company/:id', element: <Company /> },
        { path: 'community', element: <CommunityList /> },
        { path: 'coupon', element: <CouponList /> },
        { path: 'couponuse', element: <CouponUseList /> },
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'event', element: <EventList /> },
        { path: 'event/:id', element: <Event /> },
        { path: 'faq', element: <FaqList /> },
        { path: 'faq/:id', element: <Faq /> },
        { path: 'followus', element: <FollowUSList /> },
        { path: 'followus/:id', element: <FollowUS /> },
        { path: 'giftreq', element: <GiftReqList /> },
        { path: 'giftshop', element: <GiftList /> },
        { path: 'inquiry', element: <InquiryList /> },
        { path: 'inquiry/:id', element: <Inquiry /> },
        { path: 'lead', element: <LeadList /> },
        { path: 'mainbanner', element: <MainBannerList /> },
        { path: 'mainbanner/:id', element: <MainBanner /> },
        { path: 'maincategory', element: <MainCategoryList /> },
        { path: 'maincategory/:id', element: <MainCategory /> },
        { path: 'map', element: <CustomerMap /> },
        { path: 'member', element: <MemberList /> },
        { path: 'member/:username', element: <MemberUpdate /> },
        { path: 'member/new', element: <Member /> },
        { path: 'notice', element: <NoticeList /> },
        { path: 'notice/:id', element: <Notice /> },
        { path: 'order/:id', element: <OrderView /> },
        { path: 'point', element: <PointList /> },
        { path: 'popup', element: <PopupList /> },
        { path: 'popup/:id', element: <Popup /> },
        { path: 'process/account', element: <AccountList /> },
        { path: 'process/order', element: <OrderList /> },
        { path: 'process/order/register', element: <OrderRegister /> },
        { path: 'process/ordermanage', element: <OrderManageList /> },
        { path: 'process/shingo', element: <ShingoList /> },
        { path: 'process/spec', element: <SpecList /> },
        { path: 'process/spec/register', element: <SpecRegister /> },
        { path: 'product/booking', element: <BookingList /> },
        { path: 'product/category', element: <Category /> },
        { path: 'product/document', element: <DocsList /> },
        { path: 'product/item', element: <ProductList /> },
        { path: 'product/item/:id', element: <Product /> },
        { path: 'product/new', element: <NewProduct /> },
        { path: 'question', element: <QuestionList /> },
        { path: 'question/:id', element: <Question /> },
        { path: 'review', element: <ReviewList /> },
        { path: 'review/:id', element: <Review /> },
        { path: 'search', element: <SearchEngine /> },
        { path: 'shop/mall', element: <Mall /> },
        { path: 'shop/site', element: <Shop /> },
        { path: 'staff', element: <StaffList /> },
        { path: 'staff/:id', element: <StaffInfo /> },
        { path: 'stat', element: <StatList /> },
      ],
    },
    {
      path: '/',
      element: <BlankLayout />,
      children: [
        { path: '/', element: <Navigate to="/admin/dashboard" /> },
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
        { path: 'find/product', element: <FindProduct /> },
        { path: 'find/user', element: <FindUser /> },
        { path: 'find/company', element: <FindCompany /> },        
        { path: 'form/order', element: <FormOrder /> },
        { path: 'form/delivery', element: <FormDelivery /> },
        { path: 'form/spec', element: <FormSpec /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
